<div (click)="clicked()" style="display:flex; align-items: center; justify-content: space-between;">
  <div [ngStyle]="{'color': isSelected() ? 'black' : ''}"><ng-content></ng-content></div>
  <img [ngStyle]="{'visibility': isSelected() ? 'visible' : 'hidden'}" [src]="ascending ? '../assets/shapes/triangle-upward.png' : '../assets/shapes/triangle-downward.png'"
  class="sort-arrow">
</div>
